import { Box } from '@mui/material'
import { Navbar } from '../../components/Navbar'
import { Footer } from '../../components/Footer'
import { PageContainer } from '../../components/styled/PageContainer'
import { ApplicationForm } from './ApplicationForm'

export const GetMoreForLessForm = () => {
  return (
    <Box>
      <Navbar />
      <Box display='flex' justifyContent='center'>
        <img src={'client-static/images/Banner2026.png'} width='100%' />
      </Box>
      <PageContainer>
        <ApplicationForm />
      </PageContainer>
      <Footer />
    </Box>
  )
}
